import { Suspense, useState } from "react";
import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "./routes/ProtectedRoute";
import Callback from "./context/OAuth/Callback";
import { routes } from "./routes";
import NoSubscription from "@components/ui/NoSubscription";
import DefaultLayout from "./layouts/DefaultLayout";
import Logout from "./pages/logout";
import Login from "./pages/login";
import { Navigate } from "react-router-dom";
import SplashLoader from "./components/ui/Loaders/SplashLoader";
import { SocketProvider } from "./context/SocketContext";
import SubscribtionSuspended from "@components/ui/SubscribtionSuspended";
import { useAuthLoading, useUserData } from "./context/OAuth/AuthContext";
import MedicalViewGuard from "./routes/MedicalViewGuard";

const AppRoutes = () => {
  const { subscription, user } = useUserData();

  const { isAuthLoading } = useAuthLoading();
  const [showCreatePlan, setShowCreatePlan] = useState(false);
  const [open, setOpen] = useState(false);

  const ActiveRoute = ({ children, activeCheck }) => {
    if (isAuthLoading) {
      return <SplashLoader />;
    }

    if (!activeCheck) {
      return children;
    }

    if (!subscription) {
      return (
        <DefaultLayout>
          <NoSubscription />
        </DefaultLayout>
      );
    }

    const { status } = subscription;

    if (status === "active" || status === "pending-cancel") {
      return children;
    }

    if (status === "cancelled") {
      return (
        <DefaultLayout>
          <SubscribtionSuspended />
        </DefaultLayout>
      );
    }

    return (
      <DefaultLayout>
        <NoSubscription />
      </DefaultLayout>
    );
  };

  return (
    <SocketProvider user={user}>
      {/* <Suspense fallback={null}> */}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/callback" element={<Callback />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Routes>
                {routes.map((route) => {
                  return (
                    <Route
                      key={route.path}
                      path={route.path}
                      element={
                        <MedicalViewGuard>
                          <ActiveRoute
                            activeCheck={route.activeCheck}
                            bypassLayout={route.path === "/first-forms"}
                          >
                            {route.path === "/first-forms" ? (
                              <route.component
                                setShowCreatePlan={setShowCreatePlan}
                              />
                            ) : (
                              <DefaultLayout
                                showCreatePlan={showCreatePlan}
                                setShowCreatePlan={setShowCreatePlan}
                                open={open}
                                setOpen={setOpen}
                              >
                                <route.component />
                              </DefaultLayout>
                            )}
                          </ActiveRoute>
                        </MedicalViewGuard>
                      }
                    />
                  );
                })}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </ProtectedRoute>
          }
        />
        <Route path="/logout" element={<Logout />} />
      </Routes>
      {/* </Suspense> */}
    </SocketProvider>
  );
};

export default AppRoutes;